import React from "react";

import Label from "@busbud/design-system-components/dist/Label";

import { useStyles } from "./city-location.styles";

interface Props {
  stop_name?: string;
  city_name: string;
  fallback_name?: string;
  hide_location?: boolean;
}

export const CityLocation: React.FC<Props> = ({
  stop_name,
  city_name,
  fallback_name,
  hide_location
}) => {
  const { classes } = useStyles();

  if (!stop_name && !fallback_name) {
    return null;
  }

  let title = city_name;
  let subtitle = stop_name || fallback_name;

  if (hide_location) {
    title = "";
    subtitle = city_name;
  }

  return (
    <>
      {!!title && (
        <Label
          className={classes.label}
          component="div"
          fontWeight="bold"
          size="xs"
        >
          {title}
        </Label>
      )}
      {!!subtitle && (
        <Label
          className={classes.label}
          component="div"
          color="text.secondary.opaque"
          size="lg"
        >
          {subtitle}
        </Label>
      )}
    </>
  );
};
